import React, { useState } from 'react';
import usePageScroll from '../usePageScroll';
import * as bigSearchBarOffset from '../../utils/bigSearchBarOffset';
import { MAIN_CONTENT_BIG_SEARCHBAR_SELECTOR } from '../../utils/bigSearchBarOffset/constants';
import toggleCategoriesNavigation from '../toggleCategoriesNavigation';

/**
 * withSearchbarOnScroll HOC is responsible for showing searchbar when scrolling, optional to show the categories bar as well
 *
 * @param Composite
 * @param showCategoriesNavigation optional
 * @returns {function(*): *}
 */
const withSearchbarOnScroll = (Composite, showCategoriesNavigation = false) => {
    const SearchbarOnScrollWrapper = (props) => {
        const [showSearch, setShowSearch] = useState(false);

        usePageScroll(() => {
            const scrollDistance = window.pageYOffset - 250;
            const showCategoriesAndSearch =
                scrollDistance > bigSearchBarOffset.get(MAIN_CONTENT_BIG_SEARCHBAR_SELECTOR);

            setShowSearch(showCategoriesAndSearch);

            if (showCategoriesNavigation) {
                toggleCategoriesNavigation(showCategoriesAndSearch);
            }
        });

        return (
            <Composite primarySearchVisible={showSearch} secondarySearchVisible={false} mobileJoinVisible {...props} />
        );
    };

    return SearchbarOnScrollWrapper;
};

export default withSearchbarOnScroll;
